export default {
  canelaThin: '"Canela-Thin", serif',
  canelaThinItalic: '"Canela-Thin-Italic", serif',
  wigrumLight: '"Wigrum-Light", sans-serif',
  wigrumRegular: '"Wigrum-Regular", sans-serif',
  wigrumMedium: '"Wigrum-Medium", sans-serif',
  brandonGrotesqueRegular: '"BrandonGrotesque-Regular", sans-serif',
  brandonGrotesqueMedium: '"BrandonGrotesque-Medium", sans-serif',
};
